import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'app-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['../../project-form.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormInputComponent),
            multi: true
        }
    ]
})
export class FormInputComponent implements ControlValueAccessor {
    @Input() disabled = false;
    @Input() label: string;
    @Input() type: string;
    _value: any;
    @Input() selectOptions: string;
    @Input() error: string;
    onChange: any;
    onTouched: any;

    constructor() {
        this.onChange = (value: any) => {
        };
        this.onTouched = () => {
        };
    }

    writeValue(obj: any): void {
        this._value = obj;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/warehouse-profiles-form/form-input-component/form-input.component.ts